<template>
  <div class="white--text">
    <v-layout
      style="height: 20vh"
      class="secondary"
      row
      wrap
      justify-space-around
      align-content-center
    >
      <h1 id="skeleton">OUR GALLERY</h1>
    </v-layout>
    <div class="ma-4">
      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        INSTALLATION CEREMONY
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in bimages" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        WEEKLY MEETING
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in mimages" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        NEW MEMBERS INRODUCTION
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in newintro" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        INITIATION OF COMPREHENSIVE ANNUAL MAINTENANCE CONTRACT
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in firstproject" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        FAMILY MEET
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in getTogether" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        BIRTHDAYS CELEBRATION
      </h3>
      <v-layout row wrap justify-center>
        <v-flex
          md3
          sm6
          xs6
          v-for="(image, index) in cimages"
          :key="index"
          style="padding: 1em"
        >
          <v-img
            :src="image"
            @click="setDialog(image)"
            style="border: 5px solid #ddd; height: 100%"
          ></v-img>
        </v-flex>
      </v-layout>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        OTHER EVENTS
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in oimages" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        THIRD YEAR INSTALLATION
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in installation3" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>

      <h3
        style="
          font-weight: 700;
          color: #ec4;
          font-size: 1.4em;
          text-align: center;
        "
      >
        INAGURATION OF NEW EQUIPMENT AND REFRESHMENT ROOM FOR BLOOD DONORS
      </h3>
      <v-carousel class="my-4" height="100%" hide-delimiters>
        <v-carousel-item v-for="(images, index) in ghcollector" :key="index">
          <v-layout row wrap justify-center>
            <v-flex
              md3
              sm6
              xs6
              v-for="(image, index) in images"
              :key="index"
              style="padding: 1em"
            >
              <v-img
                :src="image"
                @click="setDialog(image)"
                style="border: 5px solid #ddd; height: 100%"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
      <v-dialog max-width="1000" v-model="dialog">
        <div>
          <img :src="modalImage" style="width: 100%; height: auto" />
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "Gallery",
  data() {
    return {
      dialog: false,
      modalImage: "",
      cimages: [
        "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/celebration_5_nwvrxy.jpg",
        "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/celebration_1_dndubu.jpg",
        "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/celebration_3_tbvcgs.jpg",
        "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/celebration_2_fjaqox.jpg",
      ],
      bimages: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1602747730/Rotary/IMAGES/ini_11_khri0e.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/ini_2_tq7z9p.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/ini_1_xy1lhb.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747729/Rotary/IMAGES/ini_4_c76ftg.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1602747729/Rotary/IMAGES/ini_5_huwskj.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747729/Rotary/IMAGES/ini_9_ydg3wj.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747729/Rotary/IMAGES/ini_7_xfaflw.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747730/Rotary/IMAGES/ini_10_zoi2na.jpg",
        ],
      ],
      mimages: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_1_jwtmpl.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_2_z0uisk.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_3_hszu6k.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_4_fifmqn.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_5_cpsrgf.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_6_xdk0n8.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_7_a8nlsa.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/meet_9_ssh1tm.jpg",
        ],
      ],
      oimages: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1602747727/Rotary/IMAGES/other_1_cpqjcf.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/other_2_dxld7b.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/other_3_irvwkl.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/other_4_n7rmkr.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/other_5_ycbbyl.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1602747728/Rotary/IMAGES/other_5_ycbbyl.jpg",
        ],
      ],
      newintro: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_1_vqrymh.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_2_elbya0.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_3_rzsflh.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_4_zy91kd.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_5_guyirj.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_6_bwbjln.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_7_o2ygvy.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1603699944/Rotary/IMAGES/new_8_do5t1v.jpg",
        ],
      ],
      firstproject: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/1_tfknxa.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/2_mxwcqp.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/3_g0aclo.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/4_kydgp4.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/5_joq9z6.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/13_b4iqy3.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/7_hkgxpc.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/8_mcmrnk.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/9_wgrilk.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646582/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/10_svchqi.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646583/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/11_etllaf.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1608646583/Rotary/Initiation%20of%20Comprehensive%20Annual%20Maintenance%20Contract/12_mjovxs.jpg",
        ],
      ],
      getTogether: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1614096578/Rotary/getTogether/3_zoku0m.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096572/Rotary/getTogether/1_oazwzw.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096576/Rotary/getTogether/2_dajs4n.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096627/Rotary/getTogether/16_ibgvp4.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1614096585/Rotary/getTogether/5_nvbwnt.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096587/Rotary/getTogether/6_qjqqzi.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096588/Rotary/getTogether/7_e4c1yb.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096589/Rotary/getTogether/8_dbtyv0.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1614096609/Rotary/getTogether/9_vkxlvl.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096614/Rotary/getTogether/10_njdjan.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096619/Rotary/getTogether/11_qpydem.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096621/Rotary/getTogether/12_sob4or.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1614096622/Rotary/getTogether/13_iv2h0c.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096623/Rotary/getTogether/14_cmj7xm.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096625/Rotary/getTogether/15_mviqyv.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1614096583/Rotary/getTogether/4_lnkis9.jpg",
        ],
      ],
      installation3: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/1_iyg6va.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/2_mrpjie.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/3_sfax9x.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/4_hyc1cm.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/5_vxztlx.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/6_dkrlrc.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1625145092/Rotary/2021%20Third%20Year%20Installation/7_luxavv.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1625145093/Rotary/2021%20Third%20Year%20Installation/8_mzqswr.jpg",
        ],
      ],
      ghcollector: [
        [
          "https://res.cloudinary.com/maxie/image/upload/v1627230410/Rotary/2021-7-24%20GH%20Collector/1_buleoz.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/2_cygrm5.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/3_wckrhn.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/4_ksr2s2.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/5_prgx49.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/6_k7zkuz.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/7_hadk4x.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230410/Rotary/2021-7-24%20GH%20Collector/8_l1cpcb.jpg",
        ],
        [
          "https://res.cloudinary.com/maxie/image/upload/v1627230410/Rotary/2021-7-24%20GH%20Collector/9_rhtwpi.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230411/Rotary/2021-7-24%20GH%20Collector/10_vyrr5v.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230410/Rotary/2021-7-24%20GH%20Collector/11_vac98g.jpg",
          "https://res.cloudinary.com/maxie/image/upload/v1627230410/Rotary/2021-7-24%20GH%20Collector/12_mdctwq.jpg",
        ],
      ],
    };
  },
  methods: {
    setDialog(image) {
      // console.log(image);
      this.dialog = true;
      this.modalImage = image;
    },
  },
};
</script>
<style>
#skeleton {
  animation: fadeInUp 1s ease-in-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>